module.exports = __webpack_public_path__ + "img/questions.d68cd846.png";